<div *ngIf="visible()" class="hidden md:flex mb-5 flex-wrap gap-1">
  <!-- <div
    *ngFor="let slide of slides"
    class="cajita p-0 border-round-md"
    [ngStyle]="{ 'background-image': 'url(' + slide?.imageTablet + ')' }"
  ></div> -->

  @for(slide of slides; track $index){
  <div
    class="cajita p-0 border-round-md"
    (click)="onClickValueBox($event, $index)"
  >
    <a [href]="slide.url">
      <img
        [src]="slide.imageTablet"
        [alt]="slide.alt"
        [title]="slide.title"
        class="w-100 h-100 lazyload border-round-md"
      />
    </a>
  </div>
  }
</div>

<div *ngIf="visible()" class="flex md:hidden mb-5 flex-wrap gap-1">
  <!-- <div
    *ngFor="let slide of slides"
    class="cajita_mobile p-0 border-round-md"
    [ngStyle]="{ 'background-image': 'url(' + slide?.imageOverlay + ')' }"
  ></div> -->
  @for(slide of slides; track $index){
  <div
    class="cajita_mobile p-0 border-round-md"
    (click)="onClickValueBox($event, $index)"
  >
    <a [href]="slide.url">
      <img
        [src]="slide.imageMobile"
        [alt]="slide.alt"
        [title]="slide.title"
        class="w-100 h-100 lazyload border-round-md"
      />
    </a>
  </div>
  }
</div>
